import routing from '../services/routing';

export default (data: { redirect_uri?: string }) => {
    if (data.redirect_uri) {
        routing.location.href = data.redirect_uri;
    } else {
        throw new Error('REDIRECT_URI_NOT_SPECIFIED');
    }
};
